<div class="shipping-details-popup-wrapper  mt-3">
    <p *ngIf="loading" class="text-muted">Indlæser ...</p>

    <div *ngIf="!loading">
        <app-shipment-edit-form [_shipment]="_shipment" [shipmentRoutes]="shipmentRoutes"></app-shipment-edit-form>
    </div>
</div>

